module.exports = __webpack_public_path__ + "img/delete-icon.9769e11c.svg";